import { Dispatch } from 'redux';
import {
  FETCH_TMS_TRANSLATIONS,
  FETCH_TMS_CONFIG,
  FETCH_TMS_ERRORS,
  FETCH_TMS_TRANSLATIONS_COMPLETE,
  FETCH_TMS_CONFIG_COMPLETE,
  FETCH_TMS_ERRORS_COMPLETE
} from './types';
import axios from 'axios';
import { unflatten } from 'flat';
import { find, get } from 'lodash';
import { ReduxStore } from '../payload-types';
import { LINKS } from '@trip-ux/constants';

export const convertLabels = (data, lang, translationSpace, translation) => ({
  data: unflatten(get(find(data, { language: lang }), 'labels', {})),
  translationSpace,
  translation,
  language: lang
});

export const getTmsData =
  (typeComplete: string, translationSpace: string, translation: string, lang: string, typeTms: string) =>
  (dispatch: Dispatch, getState: () => ReduxStore): Promise<void> => {
    if (!translationSpace || !translation) {
      dispatch({
        type: typeComplete,
        payload: { translationSpace, translation, language: lang, error: new Error('Missing TMS parameters') }
      });
      return Promise.resolve();
    }
    dispatch({ type: typeTms, payload: { translationSpace, translation, language: lang } });
    const contextPath = get(getState(), 'config.options.contextPath', '');
    const tmsUrl = `${contextPath}/tms/translationspaces/${translationSpace}/translations/${translation}`;
    return axios
      .get(tmsUrl, {
        params: { lang },
        headers: { 'Content-Type': 'application/json' }
      })
      .then(({ data }) => {
        dispatch({
          type: typeComplete,
          payload: convertLabels(data, lang, translationSpace, translation)
        });
      })
      .catch(e => {
        dispatch({
          type: typeComplete,
          payload: {
            translationSpace,
            translation,
            language: lang,
            error: e
          }
        });
      });
  };

export const getTmsTranslations = (translationSpace: string, translation: string, lang: string) =>
  getTmsData(FETCH_TMS_TRANSLATIONS_COMPLETE, translationSpace, translation, lang, FETCH_TMS_TRANSLATIONS);

export const getTmsConfiguration = (translationSpace: string, translation: string, lang: string) =>
  getTmsData(FETCH_TMS_CONFIG_COMPLETE, translationSpace, translation, lang, FETCH_TMS_CONFIG);

export const getTmsErrors = (translationSpace: string, translation: string, lang: string) =>
  getTmsData(FETCH_TMS_ERRORS_COMPLETE, translationSpace, translation, lang, FETCH_TMS_ERRORS);
